/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
class StatusModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         eventData: {}
      };
   }
   componentDidMount() {
   }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Change Status</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>

                     <div className="modal-body lst-pop ">
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label className="deposite-user-first"><h4 className="text-blue">qqww11</h4></label>
                           </div>
                           <div className="col-md-8">
                              <label className="deposite-user-first text-green">Active</label>
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-6 text-center">
                              <label className="deposite-user-first d-block">User Active</label>
                              <label className="switch mt-1">
                                 <input type="checkbox" checked="" />
                                 <span className="slider round"></span>
                              </label>
                           </div>
                           <div className="col-md-6 text-center">
                              <label className="deposite-user-first d-block">Bet Active</label>
                              <label className="switch mt-1">
                                 <input type="checkbox" checked="" />
                                 <span className="slider round"></span>
                              </label>
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" name="mpassword" id="mpassword" required="" />
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                        <a href="" className="pop-edit-btn mr-1" style={{cursor: "pointer"}}>Back</a>
                        <a href="" className="pop-edit-btn" style={{cursor: "pointer"}}>Submit</a>
                     </div>
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>           
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(StatusModel);